import { lazy } from 'react';
import { PartnerViewExtensions } from '@ayocore/erp/crm/client/components/Partners/views/PartnerViewExtensions';

const PartnerCounterpartiesTab = lazy(() =>
  import('../components/Counterparties/PartnerCounterpartiesTab').then(m => ({
    default: m.PartnerCounterpartiesTab,
  }))
);

/**
 * Регистрирует расширения accounting для PartnerView.
 * - Добавляет вкладку «Контрагенты» с учётными реквизитами партнёра.
 *
 * Вызывается один раз из bootstrap.ts.
 */
export function registerAccountingPartnerViewExtensions(): void {
  PartnerViewExtensions.tabs.register(({ partner }) => ({
    value: 'counterparties',
    label: 'Контрагенты',
    content: <PartnerCounterpartiesTab partnerId={partner.id} />,
  }));
}
